module.exports = __webpack_public_path__ + "static/media/QS.ea743b63.svg";